/* eslint-env jest */
import {
  cameraCodeOf,
  cameraLetterOf,
  poseNumberOf,
  cameraLabelOf,
  byCameraThenPose,
} from './cameraSort';

// Guards the customer download page's camera labelling + sort for senior sessions
// split across multiple cameras (e.g. 213-S002D-... and 213-S002I-...). Pose
// numbers COLLIDE across cameras, so the camera letter — not the pose number — is
// the grouping key.
const img = (url, number) => ({ url, number });
const item = (url, number) => ({ image: img(url, number) });

describe('cameraSort', () => {
  describe('cameraCodeOf / cameraLetterOf', () => {
    it('extracts the camera code and letter from a pose filename', () => {
      expect(cameraCodeOf(img('213-S002I-213RVXKSWM-13.png'))).toBe('S002I');
      expect(cameraLetterOf(img('213-S002I-213RVXKSWM-13.png'))).toBe('I');
      expect(cameraLetterOf(img('213-S002D-213RVXKSWM-01.png'))).toBe('D');
    });

    it('returns empty for non-conforming urls and missing input', () => {
      expect(cameraCodeOf(img('sync_img20260623-23-7lt509.png'))).toBe('');
      expect(cameraLetterOf(img(undefined))).toBe('');
      expect(cameraLetterOf(undefined)).toBe('');
    });
  });

  describe('poseNumberOf', () => {
    it('prefers the numeric `number` attribute (a string)', () => {
      expect(poseNumberOf(img('213-S002I-213RVXKSWM-13.png', '13'))).toBe(13);
    });

    it('falls back to the filename when number is absent', () => {
      expect(poseNumberOf(img('213-S002I-213RVXKSWM-07.png'))).toBe(7);
    });

    it('is 0 when unknown', () => {
      expect(poseNumberOf(img('weird.png'))).toBe(0);
    });
  });

  describe('cameraLabelOf', () => {
    it('combines camera letter and pose', () => {
      expect(cameraLabelOf(img('213-S002I-213RVXKSWM-13.png', '13'))).toBe('Camera I · Pose 13');
    });

    it('falls back to pose-only when the camera is unknown', () => {
      expect(cameraLabelOf(img('sync.png', '4'))).toBe('Pose 4');
    });
  });

  describe('byCameraThenPose', () => {
    it('groups by camera letter, then orders by pose number', () => {
      const items = [
        item('213-S002I-213RVXKSWM-13.png', '13'),
        item('213-S002D-213RVXKSWM-02.png', '2'),
        item('213-S002I-213RVXKSWM-01.png', '1'),
        item('213-S002D-213RVXKSWM-01.png', '1'),
      ];
      const sorted = [...items].sort(byCameraThenPose).map((i) => i.image.url);
      expect(sorted).toEqual([
        '213-S002D-213RVXKSWM-01.png',
        '213-S002D-213RVXKSWM-02.png',
        '213-S002I-213RVXKSWM-01.png',
        '213-S002I-213RVXKSWM-13.png',
      ]);
    });

    it('does not collapse colliding pose numbers across cameras', () => {
      const items = [
        item('213-S002I-213RVXKSWM-01.png', '1'),
        item('213-S002D-213RVXKSWM-01.png', '1'),
      ];
      const sorted = [...items].sort(byCameraThenPose).map((i) => cameraLetterOf(i.image));
      expect(sorted).toEqual(['D', 'I']);
    });

    it('sorts camera-less items last', () => {
      const items = [
        item('sync_img.png', '1'),
        item('213-S002A-213RVXKSWM-01.png', '1'),
      ];
      const sorted = [...items].sort(byCameraThenPose).map((i) => i.image.url);
      expect(sorted[0]).toBe('213-S002A-213RVXKSWM-01.png');
    });
  });
});
